@if (room()) {
  <era-room-status class="text-white"> </era-room-status>
}